import { Observable } from 'rxjs';
import { IOAGFLTStatus } from 'src/app/core/models/itinerary.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-oag-flt-status-modal',
  templateUrl: './oag-flt-status-modal.component.html',
  styleUrls: ['./oag-flt-status-modal.component.scss']
})
export class OagFltStatusModalComponent implements OnInit, OnChanges {
  @Input() isActive: boolean;

  @Output() closeModal = new EventEmitter<boolean>();

  oAGFLTStatus$: Observable<IOAGFLTStatus>;

  constructor(private itineraryService: ItineraryService) {}

  ngOnInit(): void {
    this.oAGFLTStatus$ = this.itineraryService.getIOAGFLTStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes?.isActive?.currentValue) {
        this.itineraryService.dispatchGetOAGFLTStatus();
      }
    }
  }
}
